export const ru = {
    fill_your_en_data: 'Пожалуйста не забудьте добавить ваше имя и фамилию на латинице в блоке персональной информации',
    choose_seats_available: 'Доступен выбор места на борту. Для этого напишите, пожалуйста, в чат по заявке',
    reservation: 'Забронирован до {date} • Билет будет оформлен после согласования командировки',
};
